<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="470">
    <v-card>
        <v-card-title>
            KIND
        </v-card-title>
        <v-card-text>
             <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                 v-model="kind.name"
                  label="Name *"
                  :rules="textRules"
                required
                ></v-text-field>

                <v-text-field
                 v-model="kind.description"
                  label="Description"
                ></v-text-field>

             </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="default" small rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    kind: {
        type: Object,
        default: ()=>{ return {}}
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      }
  },
  watch: {
    show () {
      if (this.show == false) {
        this.newpassword = ''
        this.show1=false
      } else {
        this.kind.password =''
      }
    }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.emitToParent(this.state)
        }
      },
    emitToParent (action) {
      this.$emit('DialogEvent', {action: action, kind:this.kind})
    }
  }
}
</script>
